import { render, staticRenderFns } from "./OutboundRulesets.vue?vue&type=template&id=2c3375a2&scoped=true&"
import script from "./OutboundRulesets.vue?vue&type=script&lang=js&"
export * from "./OutboundRulesets.vue?vue&type=script&lang=js&"
import style0 from "./OutboundRulesets.vue?vue&type=style&index=0&id=2c3375a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3375a2",
  null
  
)

export default component.exports